<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup Twilio</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    <blaze-copy-connector-config-env-button
      [coupledConnector]="coupledConnector$ | async"
      (copyConfiguration)="copyConfiguration($event)"
    />
    <button
      [disabled]="connectorForm.invalid || isLoading"
      (click)="saveConnector()"
      blazeBarButton="primary"
    >
      {{ saveButtonLabel }}
    </button>
  </ng-container>

  <div content class="dialog-content">
    <form class="form" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Name Your Connector</label>
        <input
          type="text"
          formControlName="connectorName"
          name="connectorName"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Twilio account ID</label>
        <input
          type="text"
          formControlName="twilioAccountId"
          name="twilioAccountId"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Auth token</label>
        <input
          type="text"
          formControlName="authToken"
          name="authToken"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Phone number</label>
        <input
          type="tel"
          formControlName="phoneNumber"
          name="phoneNumber"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <div class="form-control mb-22">
        <mat-slide-toggle class="bd-toggle" formControlName="useWebhook"
          >Set up webhook</mat-slide-toggle
        >
      </div>

      @if (connectorForm.controls.useWebhook.value) {
        <div class="form-control">
          <blaze-webhook-id-input [baseUrl]="webhookBaseUrl" formControlName="webhookId" />
        </div>
      }
    </form>
  </div>
</blaze-panel>
